import React from "react";
import styles from "../styles";

const TermsAndCondition = () => {
  return (
    <React.Fragment>
      <span className="root">
        <span className="header">
          LICENCE D’UTILISATION DU LOGICIEL ANYWARE® D’TRENDTREND AnyWARE®
          CONTRAT DE LICENCE UTILISATEUR FINAL DU LOGICIEL
        </span>

        <span className="lineBreak">
          EN CLIQUANT SUR LE BOUTON « ACCEPTER » CI-DESSOUS, VOUS ACCEPTEZ LES
          CONDITIONS DE LA LICENCE D’UTILISATION, PAR LESQUELLES VOUS SEREZ DÈS
          LORS LIÉ
        </span>

        <span className="lineBreak">
          La présente licence d’utilisation (ci-après « <b>la Licence</b> »),
          telle que nous pouvons la modifier de temps à autre conformément à
          l’article 12, est un contrat juridiquement contraignant entre vous
          (une personne physique ou morale) et TREND Networks Limited (ci-après
          « <b>TREND</b> ») quant à votre accès et à votre utilisation du
          logiciel AnyWARE® d’TREND qui accompagne cette Licence et peut inclure
          des éléments multimédias, des documents imprimés, des documents
          électroniques ou « en ligne », et des services Internet qui y sont
          liés (ci-après « <b>le Logiciel</b> »). Le Logiciel vous permet
          d’accéder et d’interagir avec des données issues des équipements,
          dispositifs et outils de test compatibles d’TREND (ci-après «{" "}
          <b>les Outils</b> »). Le Logiciel peut être consulté sur n’importe
          quel appareil par l’intermédiaire d’un navigateur Internet ou être
          téléchargé et installé sur un ordinateur.
        </span>

        <span className="lineBreak">
          <b>
            IMPORTANT – VEUILLEZ LIRE ATTENTIVEMENT LES TERMES DE CETTE LICENCE.
          </b>
          ELLE CONTIENT DES DISPOSITIONS IMPORTANTES QUI VOUS CONCERNENT, VOUS
          ET VOTRE UTILISATION DU LOGICIEL, ET QUE VOUS DEVEZ ÉVALUER PAR
          RAPPORT À LA VERSION ACTUELLE DE LA LICENCE À SA DATE D’ENTRÉE EN
          VIGUEUR. EN CRÉANT UN COMPTE, EN INSTALLANT, CONSULTANT OU UTILISANT
          LE LOGICIEL OU UNE PARTIE DE CELUI-CI, VOUS RECONNAISSEZ QUE VOUS AVEZ
          LU ET COMPRIS LES CONDITIONS DE LA PRÉSENTE LICENCE ET QUE VOUS
          ACCEPTEZ D’ÊTRE LIÉ PAR CELLES-CI EN VOTRE NOM PROPRE ET, LE CAS
          ÉCHÉANT, AU NOM DE L’ENTREPRISE OU AUTRE PERSONNE MORALE QUI VOUS
          EMPLOIE OU QUE VOUS REPRÉSENTEZ. SI VOUS N’ACCEPTEZ PAS CES
          CONDITIONS, NE CONSULTEZ PAS, N’INSTALLEZ PAS, NE COPIEZ PAS ET
          N’UTILISEZ PAS LE LOGICIEL. SI VOUS REFUSEZ UNE MODIFICATION APPORTÉE
          À LA PRÉSENTE LICENCE, VOUS N’AUREZ PLUS AUCUN DROIT OU LICENCE POUR
          CONSULTER OU UTILISER LE LOGICIEL ET DEVREZ IMMÉDIATEMENT LE
          DÉSINSTALLER ET CESSER DE LE CONSULTER OU DE L’UTILISER.
        </span>

        <span className="lineBreak">
          VOUS DÉCLAREZ ET GARANTISSEZ QUE VOUS PRENEZ PART À LA PRÉSENTE
          LICENCE DANS LE CADRE DE VOS ACTIVITÉS PROFESSIONNELLES OU À DES FINS
          COMMERCIALES (ET NON EN TANT QUE PARTICULIER). TOUTEFOIS, SI DES
          DISPOSITIONS DE PROTECTION DES CONSOMMATEURS S’APPLIQUENT DU FAIT DE
          LA LÉGISLATION EN VIGUEUR, LA PRÉSENTE LICENCE N’AFFECTE NI NE PORTE
          ATTEINTE AUX DROITS QUE VOUS POURRIEZ AVOIR. SI VOUS CONCLUEZ LA
          PRÉSENTE LICENCE AU NOM D’UNE ENTREPRISE OU D’UNE AUTRE PERSONNE
          MORALE, VOUS DÉCLAREZ ET GARANTISSEZ QUE VOUS AVEZ LE POUVOIR DE LIER
          CETTE ENTREPRISE OU PERSONNE MORALE AUX DISPOSITIONS DE LA PRÉSENTE
          LICENCE, AUQUEL CAS LES TERMES « VOUS » OU « VOTRE » DÉSIGNENT
          ÉGALEMENT L’ENTREPRISE OU LA PERSONNE MORALE QUE VOUS REPRÉSENTEZ OU
          QUI VOUS EMPLOIE, LES ENTREPRISES QUI LUI SONT LIÉES ET L’ENSEMBLE DE
          LEURS ADMINISTRATEURS, DIRIGEANTS, SALARIÉS, AGENTS ET REPRÉSENTANTS.
        </span>

        <ol>
          <li>
            <b> UTILISATION DU LOGICIEL</b>
            <ol>
              <li>
                Sous réserve de votre respect des termes de la présente Licence,
                TREND vous accorde un droit et une licence non exclusifs, non
                transférables, non susceptibles de sous-licence, révocables, et
                limités, de télécharger, installer, activer, consulter ou
                utiliser d’une autre manière des versions du code objet du
                Logiciel sur un appareil dont vous êtes propriétaire ou que vous
                contrôlez, uniquement et exclusivement pour vos opérations
                internes, comme autorisé par cette Licence.
              </li>
              <li>
                Vous pouvez autoriser un tiers et des utilisateurs au sein de
                votre entreprise ou organisation (ci-après «{" "}
                <b>les Utilisateurs autorisés </b>») à accéder au Logiciel et à
                l’utiliser dans le cadre normal de leur travail si cette
                utilisation est exclusivement : (i) pour votre compte ; (ii)
                pour vos opérations internes ; (iii) conformément à la présente
                Licence. Avant de fournir à vos Utilisateurs autorisés l’accès
                au Logiciel, vous vous assurerez que tous acceptent de se
                conformer aux termes de la présente Licence et qu’ils ont été
                avisés de la collecte, de l’utilisation et du partage de leurs
                données personnelles par TREND conformément aux modalités de la
                Politique de confidentialité d’TREND. Toute référence à « vous »
                ou « votre » dans la présente Licence doit également être
                interprétée comme incluant vos Utilisateurs autorisés. Les
                éléments suivants sont de votre responsabilité : (a) identifier
                et authentifier tous les Utilisateurs autorisés ; (b) approuver
                l’accès de ces Utilisateurs autorisés au Logiciel ; (c) vous
                assurer que les Utilisateurs autorisés respectent la présente
                Licence ; (d) disposer de contrôles pour empêcher tout accès et
                toute utilisation non autorisés par des Utilisateurs autorisés ;
                (e) préserver la confidentialité des noms d’utilisateur, des
                mots de passe et des informations de votre compte ; (f) fournir
                ou obtenir toute notification ou tout consentement nécessaire
                des Utilisateurs autorisés conformément à la législation en
                vigueur, notamment avant l’activation de la géolocalisation dans
                les Outils. TREND n’est pas responsable des dommages causés par
                vos Utilisateurs autorisés, y compris par des personnes qui
                n’étaient pas autorisées à avoir accès au Logiciel mais qui ont
                pu y accéder parce que les noms d’utilisateur, mots de passe ou
                comptes n’ont pas été résiliés à temps, dans votre
                infrastructure locale de gestion des identités, sur vos
                appareils locaux ou autre, par vous ou en votre nom. Vous êtes
                responsable de toutes les activités qui se produisent sous ou en
                relation avec votre nom d’utilisateur, vos mots de passe ou
                votre compte ainsi qu’avec ceux de vos Utilisateurs autorisés,
                ou à la suite de votre accès au Logiciel ou de l’accès au
                Logiciel par un Utilisateur autorisé ; vous consentez à informer
                TREND immédiatement et par écrit de toute utilisation non
                autorisée. Vous acceptez de fournir tous les efforts
                raisonnables pour empêcher des tiers non autorisés d’accéder au
                Logiciel. Vous serez responsable de tous les actes et omissions
                de tout Utilisateur autorisé ; vous indemniserez TREND de tous
                les coûts, dépenses, créances, pertes ou dommages encourus ou
                subis par TREND, ou pour lesquels TREND peut devenir
                responsable, qu’ils soient directs, indirects ou consécutifs, et
                y compris toute perte économique ou autre perte de profits,
                d’activité ou de clientèle, et qui résulteraient de tout acte ou
                omission d’un Utilisateur autorisé.
              </li>
              <li>
                Vous devez désigner un ou plusieurs Utilisateurs autorisés en
                tant qu’administrateur de votre compte (ci-après «{" "}
                <b>les Administrateurs</b> »). Vous convenez que les
                Administrateurs peuvent, en votre nom, accorder et révoquer les
                droits d’accès et d’utilisation des autres Utilisateurs
                autorisés, à tout moment et pour toute raison. Vous pouvez
                changer d’Administrateur(s) à tout moment et pour quelque raison
                que ce soit en modifiant votre choix.
              </li>
              <li>
                Vous reconnaissez que vous êtes seul responsable (et qu’TREND
                n’a aucune responsabilité envers vous ou envers un tiers) de
                votre utilisation du Logiciel, de toute violation de vos
                obligations en vertu de la présente Licence, et des conséquences
                d’une telle violation (y compris toute perte ou tout dommage
                qu’TREND pourrait subir).
              </li>
              <li>
                Vous pouvez accéder au Logiciel sur vos appareils à l’aide d’un
                navigateur Internet. Une version autonome peut être téléchargée
                et installée sur un PC sous Microsoft Windows. Cette version
                autonome permet de communiquer avec les outils via une connexion
                directe et non via Internet.
              </li>
              <li>
                Pour télécharger, installer, activer, consulter ou utiliser de
                quelque manière que ce soit le Logiciel, vous devrez vous
                inscrire et ouvrir un compte. TREND se réserve le droit de
                refuser toute inscription, à sa seule et entière discrétion. Eu
                égard à votre utilisation du Logiciel, vous acceptez les
                obligations suivantes : (i) fournir dans votre compte des
                informations exactes, à jour et complètes ; (ii) gérer et mettre
                à jour rapidement les informations dans votre compte ; (iii)
                garantir la sécurité de vos mots de passe et accepter tous les
                risques d’accès non autorisé à votre compte et aux informations
                que vous fournissez à TREND ; (iv) nous informer rapidement si
                vous découvrez ou suspectez toute violation de sécurité liée au
                Logiciel ou à votre utilisation de celui-ci.
              </li>
              <li>
                Pour permettre à TREND d’assurer le service, la maintenance et
                l’assistance technique pour le Logiciel, vous devez accorder à
                TREND l’accès nécessaire pour se connecter à votre compte et le
                gérer comme s’il était géré par vous. Cet accès autorisé
                comprend le droit pour TREND de consulter, modifier et supprimer
                vos données.
              </li>
              <li>
                Dans la mesure permise par la loi, TREND peut supprimer
                n’importe laquelle de vos données dans la mesure où tout acte ou
                omission de votre part n’est pas conforme à la présente Licence.
                TREND essayera de vous avertir avant la suppression de vos
                données, mais l’absence d’un tel avertissement ne
                contreviendrait pas à la présente Licence. Si vous téléchargez
                vos données et les supprimez de nos serveurs, ou des serveurs
                tiers que nous utilisons, ces données téléchargées et supprimées
                ne seront plus accessibles via le Logiciel, nos serveurs, ou des
                serveurs tiers que nous utilisons.
              </li>
              <li>
                Vous êtes seul responsable de fournir et de maintenir à vos
                propres frais tous les outils, équipements, logiciels, services
                et autres éléments nécessaires à l’utilisation du Logiciel et
                des Outils (notamment tout matériel ou logiciel, modem, service
                téléphonique et accès Internet).
              </li>
              <li>
                Vous reconnaissez que votre utilisation du Logiciel peut
                nécessiter une connexion Internet et que vous pouvez supporter
                des frais de données liés aux informations transmises par votre
                appareil pendant que vous utilisez le Logiciel (qu’elles soient
                envoyées ou reçues). Vous êtes seul responsable de tels frais de
                données.
              </li>
            </ol>
          </li>

          <li>
            <b> DROITS RÉSERVÉS ET PROPRIÉTÉ</b>
            <ol>
              <li>
                Le Logiciel vous est concédé sous licence, et non vendu, pour
                une utilisation conforme aux termes de la présente Licence. La
                propriété et tous les droits concernant : (i) le Logiciel
                (notamment tous les droits de propriété intellectuelle), (ii)
                tous les contenus et tout autre matériel fourni par TREND ou nos
                concédants de licence tiers, notamment les logos TREND et
                AnyWARE® d’TREND, et tous les éléments de conceptions, textes,
                graphiques, images, informations, données, logiciels, fichiers
                sonores, et autres fichiers, ainsi que la manière dont ils sont
                utilisés (ci-après collectivement « le Contenu »), sont la
                propriété exclusive d’TREND ou de nos concédants, le cas
                échéant, sont protégés par le droit d’auteur et autres lois
                applicables, et reviennent à TREND. TREND se réserve tous les
                droits qui ne vous sont pas expressément accordés dans cette
                Licence, et aucun autre droit ne vous est accordé, de manière
                explicite ou implicite.
              </li>
              <li>
                Le Logiciel vous est concédé sous licence, et non vendu, pour
                une utilisation conforme aux termes de la présente Licence. La
                propriété et tous les droits concernant : (i) le Logiciel
                (notamment tous les droits de propriété intellectuelle), (ii)
                tous les contenus et tout autre matériel fourni par TREND ou nos
                concédants de licence tiers, notamment les logos TREND et
                AnyWARE® d’TREND, et tous les éléments de conceptions, textes,
                graphiques, images, informations, données, logiciels, fichiers
                sonores, et autres fichiers, ainsi que la manière dont ils sont
                utilisés (ci-après collectivement « le Contenu »), sont la
                propriété exclusive d’TREND ou de nos concédants, le cas
                échéant, sont protégés par le droit d’auteur et autres lois
                applicables, et reviennent à TREND. TREND se réserve tous les
                droits qui ne vous sont pas expressément accordés dans cette
                Licence, et aucun autre droit ne vous est accordé, de manière
                explicite ou implicite.
              </li>
            </ol>
          </li>

          <li>
            <b> RESTRICTIONS ET LIMITATIONS </b>
            <ol>
              <li>
                Vous comprenez et acceptez que vous n’utiliserez le Logiciel que
                d’une manière conforme à toutes les lois applicables dans la
                juridiction où vous l’utilisez. En cas de violation de la
                présente Licence, vous pourriez faire l’objet de poursuites et
                de demandes de dommages-intérêts.
              </li>
              <li>
                Vous vous abstiendrez des actions suivantes, et ne laisserez
                aucun tiers les commettre :
                <ol>
                  <li>
                    télécharger, installer, activer, consulter ou utiliser le
                    Logiciel ou le Contenu de quelque manière que ce soit sur un
                    appareil dont vous n’êtes pas propriétaire ou que vous ne
                    contrôlez pas légalement ;
                  </li>
                  <li>
                    publier, discuter, fournir, donner ou diffuser de quelque
                    manière que ce soit auprès de tiers les résultats de test
                    obtenus à partir de l’utilisation des Outils ;
                  </li>
                  <li>
                    traduire, fusionner, adapter, changer, altérer ou modifier
                    tout ou partie du Logiciel, ni permettre qu’une partie du
                    Logiciel soit combinée avec tout autre programme ou y soit
                    incorporée ;
                  </li>
                  <li>
                    désosser, décompiler, tenter de dériver le code source,
                    modifier ou désassembler le Logiciel, en tout ou en partie,
                    sauf et seulement dans la mesure où une telle opération est
                    expressément autorisée par la législation en vigueur ;
                  </li>
                  <li>
                    supprimer ou modifier toute marque ou indication de
                    propriété sur le Logiciel ;
                  </li>
                  <li>
                    créer des œuvres dérivées de l’ensemble ou d’une partie du
                    Logiciel ;
                  </li>
                  <li>
                    copier ou reproduire le Logiciel en dehors de votre
                    organisation ;
                  </li>
                  <li>
                    vendre, céder, concéder sous licence, distribuer, louer,
                    attribuer en sous-licence, prêter, fournir ou rendre
                    disponible le Logiciel à autrui, sous quelque forme que ce
                    soit, de quelle manière que ce soit, en tout ou en partie,
                    sans le consentement écrit préalable d’TREND ;
                  </li>
                  <li>
                    utiliser le Logiciel de manière illégale, à des fins
                    illégales ou de toute autre manière incompatible avec les
                    présentes dispositions, ou agir frauduleusement ou
                    malicieusement, par exemple en piratant ou en insérant un
                    code malveillant, tel que des virus ou des données
                    nuisibles, dans le Logiciel ou tout système d’exploitation ;
                  </li>
                  <li>
                    enfreindre nos droits de propriété intellectuelle ou ceux
                    d’un tiers par votre utilisation du Logiciel, notamment par
                    la soumission de matériel (dans la mesure où une telle
                    utilisation n’est pas autorisée par les présentes
                    disponibilités) ;
                  </li>
                  <li>
                    transmettre dans le cadre de votre utilisation du Logiciel
                    tout matériel diffamatoire, offensant ou autrement
                    répréhensible ;
                  </li>
                  <li>
                    utiliser le Logiciel d’une manière qui pourrait endommager,
                    désactiver, surcharger ou altérer le Logiciel (ou les
                    serveurs ou réseaux connectés au Logiciel) ;
                  </li>
                  <li>
                    utiliser le Logiciel d’une manière qui pourrait interférer
                    avec l’utilisation et la jouissance par une autre personne
                    du Logiciel (ou des serveurs ou réseaux connectés au
                    Logiciel) ;
                  </li>
                  <li>
                    développer des applications tierces qui interagissent avec
                    le Logiciel sans le consentement écrit préalable d’TREND ;
                  </li>
                  <li>
                    collecter ou récolter des informations ou des données par
                    votre utilisation du Logiciel ou des systèmes d’TREND, ou
                    tenter de déchiffrer des transmissions vers ou depuis les
                    serveurs exécutant le Logiciel ;
                  </li>
                  <li>
                    utiliser le Logiciel à des fins pour lesquelles il n’a pas
                    été conçu ou n’est pas destiné, ou à toute autre fin que
                    celles décrites dans les présentes.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b> COLLECTE ET UTILISATION DES DONNÉES</b>
            <ol>
              <li>
                Vous acceptez qu’TREND et les entreprises qui lui sont liées
                puissent recueillir et utiliser les informations techniques
                obtenues dans le cadre des services d’assistance qui vous sont
                fournis, le cas échéant, concernant le Logiciel. TREND ne peut
                utiliser ces informations que pour améliorer ses produits ou
                pour vous fournir des solutions ou des services personnalisés et
                ne divulguera pas ces informations sous une forme qui vous
                identifie personnellement.
              </li>
              <b class="subHeading">Données personnelles</b>
              <li>
                Vous reconnaissez que lorsque vous téléchargez, installez,
                activez, consultez ou utilisez le Logiciel de quelque manière
                que ce soit, TREND peut utiliser des moyens automatiques
                (notamment des cookies et des balises Web) pour recueillir des
                informations sur votre appareil et sur votre utilisation du
                Logiciel. Vous et vos Utilisateurs autorisés pouvez également
                être tenus de fournir certains renseignements personnels pour
                télécharger, installer, activer, consulter ou utiliser le
                Logiciel ou certaines de ses caractéristiques ou
                fonctionnalités. En vertu de la législation sur la protection
                des données, nous sommes tenus de vous fournir certaines
                informations sur qui nous sommes, comment nous traitons vos
                données personnelles et à quelles fins, ainsi que sur vos droits
                concernant vos données personnelles et comment les exercer. Ces
                informations sont fournies dans la politique de confidentialité
                d’TREND, disponible sur
                <a
                  href="https://www.trend-networks.com/FR/FR/Privacy-Policy.aspx"
                  target="_blank"
                >
                  <b>
                    https://www.trend-networks.com/FR/FR/Privacy-Policy.aspx
                  </b>
                </a>
                ,qui peut être mise à jour de temps à autre sans préavis
                (ci-après « <b>la Politique de confidentialité </b>»). Il est
                important que vous lisiez cette Politique de confidentialité. En
                téléchargeant, en installant, en activant, en consultant ou en
                utilisant le Logiciel et en fournissant des informations au
                Logiciel ou par son intermédiaire, vous consentez, s’agissant de
                vos renseignements, à toute utilisation et à toute action
                entreprise par TREND dans le cadre de la Politique de
                confidentialité.
              </li>
              <li>
                Merci de noter que les transmissions par Internet ne sont jamais
                entièrement privées ou sécurisées et que tout message ou toute
                information que vous envoyez par l’intermédiaire du Logiciel
                peut être lu ou intercepté par des tiers, malgré l’indication
                d’une transmission cryptée.
              </li>
              <b class="subHeading">Données d’utilisateur</b>
              <li>
                S’agissant du Logiciel, TREND peut collecter et conserver les
                données saisies ou téléchargées par vous ou en votre nom via le
                Logiciel, notamment les informations relatives à votre
                utilisation des Outils et à celle des Utilisateurs autorisés
                (ci-après « <b>les Données d’utilisateur</b> »). Vous serez
                propriétaire de toutes les Données d’utilisateur et acceptez
                d’être seul responsable de celles-ci. TREND gardera
                confidentiels tous les éléments des Données d’utilisateur
                permettant d’identifier une personne, conformément à la
                Politique de confidentialité. Tous les tiers autorisés par TREND
                qui peuvent avoir accès aux Données d’utilisateur seront soumis
                à des obligations de confidentialité et devront se conformer à
                toutes les législations applicables en matière de protection des
                données. Vous autorisez TREND à utiliser, reproduire, modifier,
                adapter, traduire, divulguer, commercialiser, céder,
                transmettre, vendre, louer, licencier ou transférer toute Donnée
                d’utilisateur, en tout ou partie, dans la mesure où elle ne
                contient aucun renseignement personnel ; pour ce faire, vous lui
                accordez par les présentes un droit et une licence irrévocables,
                perpétuels, libres de redevances, transférables et pouvant faire
                l’objectif de sous-licence. En mettant en ligne ou en
                transmettant des Données d’utilisateur à l’aide du Logiciel,
                vous déclarez et garantissez que : (i) ces Données d’utilisateur
                ne sont soumises à aucune obligation de confidentialité
                vis-à-vis tiers qui serait violée par leur utilisation
                conformément aux termes de la présente Licence ; (ii) vous
                détenez et contrôlez tous les droits sur les Données
                d’utilisateur que vous créez, mettez en ligne ou transmettez, ou
                avez, de quelque manière que ce soit, tous les droits
                nécessaires pour créer, mettre en ligne ou transmettre ces
                Données d’utilisateur via le Logiciel ; (iv) les Données
                d’utilisateur, ainsi que leur utilisation, leur mise en ligne et
                leur transmission, ne contreviennent pas et ne contreviendront
                pas aux dispositions de la présente Licence ou à toute loi,
                règle ou règlement applicable. Nonobstant toute autre
                disposition de la présente Licence, TREND peut à tout moment :
                (a) supprimer les Données d’utilisateur, (b) suspendre votre
                compte et votre accès au Logiciel. Vous devez vous assurer que
                vous conservez des copies de toutes les Données d’utilisateur
                mises en ligne, transmises ou soumises à TREND par le biais du
                Logiciel ; TREND ne sera pas tenu pour responsable en cas de
                perte des Données d’utilisateur ou de perte d’utilisation du
                Logiciel.
              </li>
              <b class="subHeading">Données d’TREND</b>
              <li>
                Toutes les informations (notamment les données, analyses,
                mesures, rapports, tendances et indicateurs) liées, basées,
                dérivées ou générées à partir de Données d’utilisateur (ci-après
                « <b>Données d’TREND </b>») sont la propriété exclusive d’TREND.
                TREND a le droit d’utiliser, de recueillir, de conserver, de
                créer, d’agréger, d’exploiter, d’analyser, de modifier, de
                commercialiser, de céder, de transmettre, de vendre, de louer,
                de concéder sous licence ou de transférer les Données d’TREND
                sous toute forme, à toute fin et de toute manière que ce soit.
              </li>
            </ol>
          </li>

          <li>
            <b> MISES À JOUR</b>
            <ol>
              <li>
                TREND peut modifier le Logiciel sans préavis, notamment modifier
                les fonctionnalités ou l’apparence du Logiciel.
              </li>
              <li>
                TREND peut de temps à autre, à sa seule discrétion, développer
                et fournir des mises à jour du Logiciel qui peuvent inclure des
                mises à niveau, des corrections de bugs, des correctifs,
                d’autres corrections d’erreurs ou de nouvelles fonctionnalités
                (ci-après collectivement, en incluant la documentation qui y a
                trait, « <b>les Mises à jour </b>»). Les Mises à jour peuvent
                également modifier ou supprimer dans leur intégralité certaines
                caractéristiques et fonctionnalités. Vous convenez qu’TREND n’a
                aucune obligation de fournir des Mises à jour ou de continuer à
                fournir ou à rendre accessibles des fonctions ou fonctionnalités
                particulières. En fonction des paramètres de votre appareil,
                lorsque celui-ci se connecte à Internet : (i) le Logiciel
                téléchargera et installera automatiquement toutes les Mises à
                jour disponibles, ou (ii) vous pouvez recevoir une notification
                ou être invité à télécharger et installer les Mises à jour
                disponibles. Afin de pouvoir utiliser pleinement le Logiciel,
                vous devez télécharger et installer rapidement toutes les Mises
                à jour. Vous reconnaissez que le Logiciel ou des éléments de
                celui-ci peuvent ne pas fonctionner correctement si vous ne le
                faites pas. Vous acceptez en outre que toutes les Mises à jour
                soient considérées comme faisant partie du Logiciel et soient
                soumises à toutes les dispositions de la présente Licence.
              </li>
            </ol>
          </li>

          <li>
            <b> LIENS VERS DES SITES TIERS ET ASSISTANCE </b>
            <ol>
              <li>
                Dans le cadre de votre utilisation du Logiciel, vous pouvez
                créer des liens vers des sites tiers (par exemple vers «
                TeamViewer », une plate-forme de téléassistance et d’impression
                à distance). Les sites tiers ne sont pas sous le contrôle
                d’TREND, et TREND n’est pas responsable du contenu, des
                changements ou des mises à jour du moindre site tiers, ni des
                liens que de tels sites peuvent contenir. TREND n’est pas
                responsable de la diffusion sur le Web ou de toute autre forme
                de transmission reçue de sites tiers. TREND vous propose ces
                liens vers des sites tiers uniquement pour des raisons de
                commodité. Leur inclusion ne signifie pas qu’TREND les
                recommande.
              </li>
              <li>
                Si vous souhaitez en savoir plus sur le Logiciel ou si vous
                rencontrez des problèmes lors de son utilisation, merci de
                consulter le site{" "}
                <a
                  href="https://www.trend-networks.com/in/en/index.aspx"
                  target="_blank"
                >
                  <b>www.trend-networks.com</b>
                </a>{" "}
                pour obtenir des coordonnées téléphoniques et électroniques pour
                votre zone. TREND ne sera pas tenu de fournir des services
                d’assistance au titre de la présente Licence. Si vous avez
                besoin d’assistance, celle-ci peut être fournie sur demande, en
                fonction du temps et des coûts. La présente Licence ne vous
                donne aucun droit à des mises à jour ou mises à niveau du
                Logiciel ou à des extensions ou améliorations du Logiciel
                développées par ou au nom d’TREND à l’avenir. TREND peut
                proposer des services d’assistance séparément. Tout code
                informatique supplémentaire ou matériel associé qu’TREND vous
                fournit dans le cadre de tout service d’assistance doit être
                considéré comme faisant partie du Logiciel et sera soumis aux
                conditions de la présente Licence.
              </li>
            </ol>
          </li>

          <li>
            <b> INFORMATIONS CONFIDENTIELLES </b> <br />
            Vous reconnaissez et acceptez que le Logiciel (à l’exclusion de tout
            Logiciel en source ouverte) et toutes les informations émanant du
            Logiciel et des activités d’TREND sous quelque forme que ce soit
            sont la propriété intellectuelle d’TREND et sont considérés comme
            des informations confidentielles d’TREND (ci-après «{" "}
            <b>les Informations confidentielles</b> »). Vous acceptez de ne pas
            permettre, pendant la présente Licence ou après son expiration, la
            duplication, l’utilisation ou la divulgation de ces Informations
            confidentielles à quiconque, à moins que cette duplication,
            utilisation ou divulgation ne soit au préalable spécifiquement
            autorisée par écrit par TREND. Vous devez déployer des efforts
            raisonnables pour empêcher la divulgation ou la reproduction non
            autorisée des informations confidentielles, et en aucun cas n’être
            moins attentif que vous le seriez pour vos propres informations
            confidentielles de nature similaire. Sans limiter la portée générale
            de ce qui précède, dans la mesure où la présente Licence autorise la
            copie d’informations confidentielles, toutes ces copies doivent
            comporter les mêmes indications de confidentialité, légendes et
            désignations de droits de propriété intellectuelle qui apparaissent
            dans les versions originales, et vous devez garder une trace précise
            de l’emplacement de toutes les informations confidentielles.
          </li>

          <li>
            <b> DROIT DE RÉSILIATION DE LA LICENCE</b>
            <ol>
              <li>
                La présente Licence continuera de s’appliquer jusqu’à sa
                résiliation de votre part ou de la part d’TREND comme indiqué
                dans les présentes.
              </li>
              <li>
                Vous pouvez résilier cette Licence à tout moment en cessant de
                consulter le Logiciel ou en le désinstallant intégralement et
                définitivement de votre ordinateur.
              </li>
              <li>
                Si vous ne respectez pas l’une des dispositions de la présente
                Licence, vos droits sont automatiquement et immédiatement
                résiliés sans préavis de la part d’TREND. Dans un tel cas, vous
                devez immédiatement cesser de consulter le Logiciel et le
                désinstaller.
              </li>
              <li>
                TREND peut mettre fin à votre droit d’utiliser le Logiciel à
                tout moment, avec ou sans préavis. Les dispositions de la
                présente Licence relatives à l’utilisation des données, au
                dédommagement, à la limitation de responsabilité, à la
                confidentialité, au règlement des différends et à la
                constitution et formation de l’accord perdureront au-delà de la
                résiliation ou de l’expiration de la présente Licence.
              </li>
            </ol>
          </li>

          <li>
            <b> DÉDOMMAGEMENT </b>
            <br />
            Dans toute la mesure permise par la loi, vous acceptez de défendre,
            de dédommager et de dégager de toute responsabilité TREND, ses
            filiales et les entreprises qui lui sont liées et leurs
            administrateurs, dirigeants, employés et agents respectifs face à
            toute réclamation, action en justice, poursuite ou procédure
            judiciaire, ainsi que pour tout coût et toute perte, responsabilité
            financière, dépense et demande de dommages-intérêts (y compris des
            honoraires d’avocat raisonnables) découlant de votre utilisation (ou
            de celle de toute personne agissant sous votre responsabilité) du
            Logiciel, y compris votre consultation, installation ou utilisation
            du Logiciel, ou votre violation de la présente licence.
          </li>

          <li>
            <b> LIMITATION DE RESPONSABILITÉ</b>
            <ol>
              <li>
                TREND N’EXCLUT NI NE LIMITE EN AUCUNE FAÇON SA RESPONSABILITE A
                VOTRE EGARD LORSQU’UNE TELLE EXCLUSION OU LIMITATION SERAIT
                ILLEGALE. CECI INCLUT SA RESPONSABILITE EN CAS DE DECES OU DE
                DOMMAGES CORPORELS CAUSES PAR SA NEGLIGENCE OU LA NEGLIGENCE DE
                SES EMPLOYES, AGENTS OU SOUS-TRAITANTS, OU EN CAS DE FRAUDE OU
                DE FAUSSE DECLARATION FRAUDULEUSE.
              </li>
              <li>
                VOUS COMPRENEZ ET ACCEPTEZ EXPRESSÉMENT QUE VOTRE UTILISATION DU
                LOGICIEL SOIT À VOTRE SEULE DISCRÉTION ET À VOS PROPRES RISQUES
                ET QUE LE LOGICIEL SOIT FOURNI « TEL QUEL » ET « TEL QUE
                DISPONIBLE » SANS GARANTIE D’AUCUNE SORTE, EXPLICITE OU
                IMPLICITE. VOUS ÊTES SEUL RESPONSABLE DE TOUT DOMMAGE À VOTRE
                ORDINATEUR OU AUTRE APPAREIL, OU DE TOUTE PERTE DE DONNÉES
                RÉSULTANT D’UNE TELLE UTILISATION. DE PLUS, TREND REJETTE
                EXPRESSÉMENT TOUTE AUTRE GARANTIE ET CONDITION DE QUELQUE NATURE
                QUE CE SOIT CONCERNANT LE LOGICIEL, EXPRESSE OU IMPLICITE,
                NOTAMMENT LES GARANTIES ET CONDITIONS IMPLICITES DE QUALITÉ
                MARCHANDE, D’ADÉQUATION À UN USAGE PARTICULIER ET D’ABSENCE DE
                CONTREFAÇON. CERTAINES JURIDICTIONS N’AUTORISENT PAS LA
                RENONCIATION OU L’EXCLUSION DE GARANTIES IMPLICITES, DE SORTE
                QUE CELLES-CI PEUVENT NE PAS VALOIR DANS VOTRE CAS. TREND NE
                GARANTIT PAS L’ABSENCE D’ÉLÉMENTS VENANT INTERFÉRER AVEC VOTRE
                JOUISSANCE DU LOGICIEL, NI QUE LES FONCTIONS CONTENUES DANS LE
                LOGICIEL, OU LES SERVICES EXÉCUTÉS OU FOURNIS PAR CELUI-CI,
                RÉPONDRONT À VOS EXIGENCES, NI QUE LE FONCTIONNEMENT DU LOGICIEL
                OU DE CES SERVICES SERA EXEMPT D’INTERRUPTION OU D’ERREUR, NI
                QUE LES DÉFAUTS DU LOGICIEL OU DES SERVICES SERONT CORRIGÉS.
                AUCUN CONSEIL OU INFORMATION DONNÉ PAR TREND OU SES
                REPRÉSENTANTS AUTORISÉS, PAR ORAL OU PAR ÉCRIT, NE SAURAIT
                CONSTITUER UNE GARANTIE.
              </li>
              <li>
                VOUS COMPRENEZ ET ACCEPTEZ EXPRESSÉMENT QUE, SAUF EN CE QUI
                CONCERNE L’ARTICLE 10.1, TREND, SES FILIALES, LES ENTREPRISES
                QUI LUI SONT LIÉES, ET SES CONCÉDANTS DE LICENCE N’ONT AUCUNE
                RESPONSABILITÉ ENVERS VOUS POUR TOUTE PERTE OU TOUT DOMMAGE DE
                QUELQUE NATURE OU MONTANT QUE CE SOIT, SELON TOUTE DOCTRINE
                JURIDIQUE, QUE CES PERTES OU DOMMAGES SOIENT DIRECTS, INDIRECTS,
                ACCESSOIRES, SPÉCIAUX, CONSÉCUTIFS OU EXEMPLAIRES, ET QUE VOUS
                AYEZ OU NON SUBI OU SOUFFERT DE CES PERTES OU DOMMAGES PAR VOTRE
                UTILISATION DU LOGICIEL, Y COMPRIS TOUTE PERTE OU TOUT DOMMAGE À
                VOS APPAREILS, ET CECI QUE VOUS OU VOS REPRÉSENTANTS AYEZ ÉTÉ
                INFORMÉS OU NON DE LA POSSIBILITÉ QUE CES DOMMAGES SURVIENNENT.
              </li>
              <li>
                VEUILLEZ SAUVEGARDER LE CONTENU ET LES DONNEES UTILISES AVEC LE
                LOGICIEL. TREND VOUS RECOMMANDE DE SAUVEGARDER L’ENSEMBLE DU
                CONTENU ET DES DONNEES UTILISES EN RELATION AVEC LE LOGICIEL,
                AFIN DE VOUS PROTEGER EN CAS DE PROBLEMES AVEC CE DERNIER.
              </li>
            </ol>
          </li>

          <li>
            <b> MODIFICATIONS DE LA LICENCE </b>
            <br />
            TREND peut à tout moment modifier la Licence (y compris quant aux
            coûts que vous devez payer pour l’utilisation du Logiciel) en vous
            en avisant – que ce soit par e-mail, en ligne, par le biais du
            Logiciel ou par tout autre moyen. Une telle modification sera
            considérée comme entrant en vigueur trente (30) jours suivant la
            date de cet avis. Vous devez prendre en compte et accepter de telles
            modifications, comme précisé dans l’avis. Faute d’acceptation des
            modifications de votre part, TREND pourra résilier la présente
            Licence moyennant un préavis d’un (1) mois à votre attention.
          </li>

          <li>
            <b> NOTIFICATIONS </b>
            <ol>
              <li>
                Toute notification ou autre communication adressée à une partie
                dans le cadre de la présente Licence doit être faite par écrit
                et doit être remise à son siège social (dans le cas d’une
                société) ou à son principal établissement (dans tout autre cas)
                en main propre, par courrier affranchi en prioritaire, ou par un
                autre service de livraison pour le lendemain.
              </li>
              <li>
                Toute notification ou communication sera réputée avoir été reçue
                : (i) si elle est remise en main propre, au moment de la
                signature du récépissé de livraison ou au moment où l’avis est
                remis à la bonne adresse ; (ii) si elle est expédiée par
                courrier affranchi en prioritaire ou autre service de livraison
                pour le lendemain, à 9 h le deuxième jour ouvrable suivant
                l’envoi ou à l’heure enregistrée par le service de livraison ;
                (iii) si elle est envoyée par courrier électronique, au moment
                de la transmission ou, si cette heure est en dehors des heures
                de bureau au lieu de réception (à savoir du lundi au vendredi,
                de 9 h à 17 h, un jour qui n’est pas férié au lieu de
                réception), lorsque les heures de travail reprennent.
              </li>
            </ol>
          </li>

          <li>
            <b> LOI APPLICABLE ET JURIDICTION COMPÉTENTE </b>
            La présente Licence et tout litige ou réclamation en relation avec
            celle-ci, avec son objet ou avec sa formation, ou découlant de
            celle-ci (y compris les litiges ou réclamations non contractuels),
            seront régis et interprétés conformément au droit de l’Angleterre et
            du Pays de Galles. Chaque partie accepte irrévocablement que les
            tribunaux d’Angleterre et du Pays de Galles aient compétence
            exclusive pour régler tout litige ou réclamation découlant de cette
            Licence ou en relation avec elle, son objet ou sa formation (y
            compris les litiges non contractuels).
          </li>

          <li>
            <b>DIVERS</b>
            <br />
            La présente Licence (y compris tout addendum ou amendement la
            concernant) constitue l’intégralité de l’accord entre vous et TREND
            s’agissant du Logiciel et des services d’assistance technique (le
            cas échéant) et annule et remplace toute communication, proposition
            et déclaration, orale ou écrite, antérieure ou actuelle, concernant
            le Logiciel ou tout autre sujet couvert par la présente Licence. Si
            des conditions d’une politique d’TREND ou des services d’assistance
            technique entrent en conflit avec les dispositions de la présente
            Licence, ce sont les dispositions de la présente Licence qui
            s’appliquent. Si une disposition de la présente Licence était jugée
            nulle, invalide, inexécutable ou illégale, elle serait réputée
            reformulée pour refléter l’intention initiale des parties dans toute
            la mesure possible et conformément à la législation applicable, et
            les autres dispositions demeureraient pleinement applicables et en
            vigueur. Si TREND manque d’exercer ou d’appliquer tout droit ou
            toute disposition de la présente Licence, cela ne constituerait pas
            pour autant une renonciation à ce droit ou à cette disposition, à
            moins qu’TREND ne le reconnaisse et n’y consente par écrit. Ni la
            conduite des parties ni les pratiques commerciales n’ont pour effet
            de modifier les dispositions de la présente Licence. Vous n’êtes pas
            autorisé à céder cette Licence ni aucun de vos droits en vertu de
            celle-ci sans le consentement écrit préalable d’TREND, ce qui peut
            être accordé ou conditionné à notre seule et absolue discrétion.
            Toute tentative de cession sans ce consentement sera nulle et non
            avenue. Sous réserve de la restriction susmentionnée, la présente
            Licence liera pleinement TREND et ses successeurs et ayants droit
            respectifs, et sera exécutoire à leur égard. TREND peut transférer à
            une autre organisation ses droits et obligations en vertu des
            présentes conditions.
          </li>
        </ol>
      </span>
    </React.Fragment>
  );
};

export default TermsAndCondition;



// WEBPACK FOOTER //
// ./src/components/signup/termsAndCondition/components/french.js